import { memo } from "react";
import { PositionTableSkeletonRow } from "../row/PositionTableSkeletonRow";

export const StakedPositionSkeletonRow = memo(() => <PositionTableSkeletonRow />);

StakedPositionSkeletonRow.displayName = "StakedPositionSkeletonRow";
